import React from "react"

const SubscriptionSkeleton = () => (
  <div
    className="animate-pulse space-y-6"
    aria-busy="true"
    aria-label="Loading subscription"
  >
    <section className="rounded border border-gray-200 bg-white px-5 pb-5 pt-2">
      <div className="mb-3 mt-5 h-7 w-48 rounded bg-gray-200" />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {[0, 1, 2, 3].map((i) => (
          <div key={i}>
            <div className="mb-1 h-4 w-20 rounded bg-gray-200" />
            <div className="h-6 w-32 rounded bg-gray-200" />
          </div>
        ))}
        <div className="space-y-2">
          <div className="h-4 w-20 rounded bg-gray-200" />
          <div className="h-5 w-full rounded bg-gray-200" />
        </div>
      </div>
    </section>
    <section className="rounded border border-gray-200 bg-white px-5 pb-5 pt-2">
      <div className="mb-3 mt-5 h-7 w-40 rounded bg-gray-200" />
      <div className="space-y-2">
        <div className="h-4 w-full rounded bg-gray-200" />
        <div className="h-5 w-full rounded bg-gray-200" />
        <div className="h-5 w-full rounded bg-gray-200" />
        <div className="h-5 w-full rounded bg-gray-200" />
      </div>
    </section>
    <section className="rounded border border-gray-200 bg-white px-5 pb-5 pt-2">
      <div className="mb-3 mt-5 h-7 w-40 rounded bg-gray-200" />
      <div className="h-5 w-64 rounded bg-gray-200" />
    </section>
  </div>
)

export default SubscriptionSkeleton
